export interface User {
  id: Id
  name: string
  email: Email
  email_verified_at: DateIso
  created_at: DateIso
  updated_at: DateIso
  deleted_at: null | DateIso
  role_key: UserRoles
  last_login_at: DateIso
  created_by: string
}

export enum UserRoles {
  SUPER_ADMIN = 'super-admin',
  WEREHOUSE_MANAGER = 'warehouse-manager',
  OPERATIONS_MANAGER = 'operations-manager',
  PROJECT_MANAGER = 'project-manager',
}
